import { Navigate, useParams } from 'react-router-dom';

/**
 * Param-preserving redirect for the retired `/member/:id` route (#3348):
 * forwards to the public profile `/u/:id` with the `:id` intact. `<Navigate>`
 * cannot interpolate a route param, so this reads it via `useParams`. `replace`
 * so Back does not bounce off the redirect. Lives in its own module (not in
 * routes/legacyRedirects.tsx) so that file keeps exporting only `<Route>`
 * elements and does not trip react-refresh/only-export-components.
 */
export function MemberIdRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/u/${id}`} replace />;
}
